import { ChangeDetectionStrategy, Component } from "@angular/core";

import { SvgIconComponent } from "@hermes/aphrodite-svg";

@Component({
    selector: "h-parallax-logo",
    imports: [SvgIconComponent],
    templateUrl: "./parallax-logo.component.html",
    styleUrls: ["./parallax-logo.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParallaxLogoComponent {}
